/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography, TableRow, TableCell, Box, Tooltip } from "@mui/material";
import CustomAvatar from "src/components/shared/atoms/avatar/customAvatar";
import clsx from "clsx";
import DeleteIcon from "src/assets/images/settings/deleteIcon.png";
import Button from "src/components/shared/atoms/button";
import IconButton from "@mui/material/IconButton";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useStyle from "../Styles";

interface Props {
  curr: any;
  connectedHandler: any;
  disconnectedHandler: any;
  closeHandler: any;
  loading: boolean;
  disabled: boolean;
  showUpgradePopUp?: any;
  id?: string;
}

const InternalRow: React.FC<Props> = ({
  curr,
  closeHandler,
  connectedHandler,
  disconnectedHandler,
  loading,
  disabled,
  id,
}) => {
  const { classes } = useStyle();
  return (
    <TableRow className={classes.row}>
      <TableCell className={classes.rowCell}>
        <Box className={classes.rowContent}>
          <Box className={classes.pageInfo}>
            <CustomAvatar
              src={curr.picture}
              alt={curr.name}
              className={classes.pageAvatar}
            />
            <Box>
              <Typography className={classes.pageName}>{curr.name}</Typography>
              <Typography className={classes.sourceTag}>
                Facebook Page Active Connection
              </Typography>
            </Box>
          </Box>
          <Box className={classes.actions} id={id}>
            <Button
              variant="outlined"
              handleClick={
                curr.isSelected
                  ? () => disconnectedHandler(curr)
                  : () => connectedHandler(curr)
              }
              className={clsx(classes.actionBtn, {
                [classes.btnDisconnect]: curr.isSelected,
                [classes.btnConnect]: !curr.isSelected,
              })}
              disabled={disabled}
              circular={loading}
            >
              {curr.isSelected ? "Disconnect" : "Connect Page"}
            </Button>
            <Tooltip title="Remove Page">
              <IconButton
                onClick={() => closeHandler(curr)}
                className={classes.removeBtn}
                size="small"
              >
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default InternalRow;
